"use client";

import { useParams } from "next/navigation";

import LinkWithLang, { LinkWithLangProps } from "@stadium/shared/src/components/link-with-lang";

import { decodeMeta } from "@helpers/route";

const LinkWithLangClient = (props: LinkWithLangProps) => {
  const params = useParams();
  const { origin } = decodeMeta((params?.meta as string) || "");
  return <LinkWithLang {...props} baseOrigin={origin} />;
};

export default LinkWithLangClient;
